let autocomplete;
let schoolField;
let schoolAddressField;
let schoolCityField;
let schoolStateField;
let schoolZipcodeField;

function initAutocomplete() {
  schoolField = document.querySelector('.school-field input');

  if (document.querySelector('.school-address-field input')) {
    schoolAddressField = document.querySelector('.school-address-field input');
  }

  if (document.querySelector('.school-city-field input')) {
    schoolCityField = document.querySelector('.school-city-field input');
  }

  if (document.querySelector('.school-state-field input')) {
    schoolStateField = document.querySelector('.school-state-field input');
  }

  if (document.querySelector('.school-zipcode-field input')) {
    schoolZipcodeField = document.querySelector('.school-zipcode-field input');
  }

  // Create the autocomplete object, restricting the search predictions to
  // addresses in the US.
  autocomplete = new google.maps.places.Autocomplete(schoolField, {
    componentRestrictions: { country: ['us'] },
    fields: ['name', 'formatted_address'],
    types: ['school'],
  });

  schoolField.placeholder = '';

  // When the user selects an address from the drop-down, populate the
  // address fields in the form.
  autocomplete.addListener('place_changed', fillInAddress);
}

function fillInAddress() {
  // Get the place details from the autocomplete object.
  const place = autocomplete.getPlace();
  const school = place.name.split(',')[0];
  const city = place.formatted_address.split(', ')[1];
  const state = place.formatted_address.split(', ')[2].split(' ')[0];
  const address = place.formatted_address.split(',')[0];
  const zipcode = place.formatted_address.split(', ')[2].split(' ')[1];

  schoolField.value = school;

  // Fill out school fields if they exist on the page
  if (schoolAddressField) {
    schoolAddressField.value = address;
  }

  if (schoolCityField) {
    schoolCityField.value = city;
  }

  if (schoolStateField) {
    schoolStateField.value = state;
  }

  if (schoolZipcodeField) {
    schoolZipcodeField.value = zipcode;
  }
}

export const autocompleteSchool = () => {
  window.initAutocomplete = initAutocomplete();
  // google.maps.event.addDomListener(window, 'load', initAutocomplete);
};
